<template>
  <div>
    <div class="container"
         style="min-height: 100vh;">
      <div class="wrapper">
        <div class="login_user">
          <img src="../../assets/images/logo.jpg"
               alt="">
        </div>
        <ul>
          <li>
            <i class="iconfont">&#xe60e;</i>
            <input type="text"
                   placeholder="请输入手机号"
                   v-model="phone"></li>
          <li class="code">
            <div>
              <i class="iconfont">&#xe628;</i>
              <input type="text"
                     placeholder="请输入验证码"
                     v-model="identify">
            </div>
            <button type="button"
                    @click="getCode()"
                    id="code"
                    :disabled="disable">{{code}}</button>
          </li>
          <div class="login">
            <button class="sub_btn"
                    @click="submitUser">登 录</button>
          </div>
          <p class="tab">
            <router-link :to="{name:'Register'}">无账号,立即注册</router-link>
          </p>

        </ul>
      </div>

    </div>

  </div>
</template>
<script>
import AppSetting from '../../AppSetting';
import loginService from '../../plugin/extendFn/loginService';
import store from '../../store'
export default {
  data () {
    return {
      wxuser: null,
      phone: '',

      disable: false,
      code: "获取验证码",
      name: '',
      identify: '',
      active: 1,


    }
  },
  props: {},
  watch: {

    mail (newValue, oldValue) {
      let obtn = document.getElementById('code');
      let reg = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/; //验证规则
      if (reg.test(this.mail)) {
        this.disable = false;
        obtn.style.color = '#00468f';
      } else {
        this.disable = true;
        obtn.style.color = '#666666';
      }
    },
  },
  methods: {
    tabtype (type) {
      this.active = type;
      this.phone = '';
      this.identify = '';
      this.name = '';
    },
    submitUser () {

      if (this.phone == '') {

        this.$message.error('请输入手机号！');
        return false;
      }




      if (this.identify == '') {
        this.$message.error('请输入验证码！');
        return false;
      }
      let params = {
        identify: this.identify,
        phone: this.phone,
      };

      this.$postHttp(AppSetting.baseUrl + '/student/update', params).then(async(res) => {
        console.log(res);
        if (res.data.code == 0) {
          let info = res.data.student
          await loginService.setLoginUser(info)
          if (info.uOrg) {
            this.$message({
              message: '登录成功',
              type: 'success'
            });
            this.$router.push({
              name: "Live",
            })
          } else {
            this.$message({
              message: '请先完善信息',
              type: 'warning'
            });
            this.$router.push({
              name: "Register",
            })
          }

        } else if (res.data.code == 1001) {

          this.$message.error('手机号码格式错误！');
        } else if (res.data.code == 2003) {

          this.$message.error('验证码错误！');
        } else if (res.data.code == 2001) {

          this.$message.error('验证码过期！');
        } else if (res.data.code == 2000) {

          this.$message.error('账号不存在，请先完成注册！');
          this.$router.push({
            name: 'Register'
          })
        } else {

          this.$message.error('绑定失败');
        }
      })

    },
    getCode () {
      if (this.phone == '') {
        this.$message.error('请输入手机号！');

        return false;
      }
      const obtn = document.getElementById('code');
      obtn.style.color = '#333333';

      this.$postHttp(AppSetting.baseUrl + '/login/identify', { phone: this.phone, type: 'LOGIN',}).then((res) => {
        console.log(res);
        if (res.data.code == 2007) {

          this.$message.error('验证码发送失败!');
        } else if (res.data.code == 0) {
          let num = 59;
          this.code = num + 's后重发';
          this.disable = true;
          let code = setInterval(() => {
            num--;
            this.code = num + 's后重发';
            if (num < 1) {
              this.disable = false;
              obtn.style.color = '#FFB441';
              this.code = '重新获取';
              clearInterval(code)
            }
          }, 1000)
          // this.toast('验证码发送成功');
        } else if (res.data.code == 2008) {
          this.$message.error('此手机号已被绑定!');
        }
      });


    },


  },
  computed: {},
  async mounted () {
    this.wxuser = await loginService.getLoginUser();
  }
}
</script>
<style scoped lang="scss">
input {
  -webkit-appearance: none; /*去除input默认样式*/
}
.container {
  width: 100%;

  box-sizing: border-box;
  position: relative;
  background: url("./img/loginBg.png") no-repeat;

  background-size: cover;
  overflow: hidden;
  .wrapper {
    width: 600px;
    height: 500px;
    margin: 80px auto;
    border-radius: 10px;
    border: 5px solid #f0f0f0;
    padding: 20px;
    box-sizing: border-box;
  }
  .login {
    height: 100px;
  }
  .login_user {
    text-align: center;

    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    span {
      font-size: 14px;
      font-weight: bold;
      color: #ffffff;
    }
    img {
      width: 150px;
      margin-top: 30px;
      /*width: 100px;*/
      /*-webkit-border-radius: 50%;*/
      /*-moz-border-radius: 50%;*/
      /*border-radius: 50%;*/
    }
  }
  .reg {
    margin-top: 20px;
  }
  ul {
    font-size: 14px;
    width: 80%;
    margin: 20px auto;
    /*background: #FFFFFF;*/
    li:nth-of-type(2) {
      border: none;
    }

    li {
      display: flex;
      width: 100%;

      margin-bottom: 10px;
      align-items: center;
      border-bottom: 1px solid #cccccc;
      &.code {
        margin-top: 20px;
      }
      i {
        font-size: 20px;
        margin-right: 10px;
      }
      span {
        color: #333333;
        text-align: justify;
        -moz-text-align-last: justify;
        text-align-last: justify;
        text-justify: distribute-all-lines;
        display: inline-block;
        width: 1.18rem;
        margin-right: 0.24rem;
      }
    }

    input {
      width: 460px;
      height: 40px;
      background: rgba(255, 255, 255, 0);
      border-radius: 5px;
      padding: 0.1rem 0.2rem;
      box-sizing: border-box;
      font-size: 14px;
      outline: none;
      border: none;
    }
    input::placeholder {
      font-size: 14px;
      color: #999999;
    }
  }
  .findpass {
    color: #007eff;
  }
  .sub_btn {
    border: none;
    outline: none;
    width: 100%;
    height: 50px;
    background: #00468f;
    border-radius: 10px;
    font-size: 18px;
    margin-top: 50px;
    color: #ffffff;
    cursor: pointer;
  }
}

.tab {
  text-align: center;
  font-size: 14px;
  margin-top: 20px;
  a {
    color: #00468f !important;
    text-align: left !important;
    text-align-last: left !important;
    margin-right: 0px !important;
    display: inline-block;
    min-width: 118px !important;
  }
}
.reg {
  text-align: center;
  a {
    color: #ffb441 !important;
    font-size: 16px;
  }
}

.code div {
  width: 350px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #cccccc;
  input {
    width: 200px;
  }
  img {
    width: 35px;
    height: 35px;
  }
}
.code button {
  width: 230px;
  border-bottom: 1px solid #cccccc;
  height: 40px;
  display: inline-block;
  margin-left: 14px;
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
  color: #333333;
  font-size: 14px;
  outline: none;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/login/index_pc.vue